import { LISTING_STATUS } from '@constants/property'
import { formatDate } from '@lib/date'
import AddToCalendar from '@global/AddToCalendar'
import { Detail, DetailHeading } from '../PropertyDetails.styled'
import * as S from './Auction.styled'

const Auction = ({ listing }) => {
  if (
    !(
      listing.auction_date &&
      listing.status !== LISTING_STATUS.SOLD &&
      !listing.underOffer
    )
  )
    return null

  return (
    <Detail>
      <DetailHeading>Auction</DetailHeading>
      <S.Auction>
        <S.AuctionInfo>
          <S.AuctionDate>
            {formatDate(new Date(listing.auction_date), 'EEEE dd MMMM')}
          </S.AuctionDate>
          <S.AuctionTime>
            {formatDate(new Date(listing.auction_date), 'h:mm a')}
          </S.AuctionTime>
        </S.AuctionInfo>

        <AddToCalendar
          text='Add to calendar'
          title={`Auction | ${listing.address}`}
          type='Auction'
          tz={listing.timezone}
          property={listing}
          start={listing.auction_date}
        />
      </S.Auction>
    </Detail>
  )
}

export default Auction
